import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { CapiLoginService } from 'app/core/extension/login/capi-login-service';
import { Observable } from 'rxjs';

/**
 * Requires users to authenticate when they access protected parts of the ui.
 *
 * You can protect a route by using it as activation guard:
 *
 *     {path: "whatever", component: WhateverComponent, canActivate: [LoginGuard]}
 *
 * Alternatively, you can hide protected parts with *ngIf="loginService.userLoggedIn",
 * and trigger login manually using loginService.requireLogin().
 */
export const canActivateLogin: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  return new Promise<boolean>((resolve) => {
    return inject(CapiLoginService).requireLogin(state.url);
  });
};
